import { Exception, setUVMessage } from 'kerium';
/**
 * @deprecated Use {@link Exception} instead
 * @category Internals
 */
export const ErrnoError = Exception;
export function withPath(e, path) {
    e.path = path;
    return e;
}
export function wrap(fs, prop, path, dest) {
    const fn = fs[prop];
    if (typeof fn !== 'function')
        throw new TypeError(`${prop} is not a function`);
    return function (...args) {
        try {
            return fn.call(fs, ...args);
        }
        catch (e) {
            throw setUVMessage(Object.assign(e, { path, dest, syscall: prop.endsWith('Sync') ? prop.slice(0, -4) : prop }));
        }
    };
}
